import React from 'react';
import { reduxForm } from 'redux-form';

import Aux from '../../common/Aux';
import Button from '../../common/form/Button';
import { ButtonGroup, InputFieldGroup } from '../../common/form';
import Spinner from '../../common/loaders/Spinner';
import Card from '../../common/Card';

const AuthForm = ({ handleSubmit, onSubmit, submitting, errorMessage }) => {

	return (
		<Aux>
			{ submitting && <Spinner /> }
			<form className="auth-page__form" onSubmit={handleSubmit(onSubmit)}>
				<h3>Investor Login</h3>
				<InputFieldGroup 
					name="username"
					custom={{
						placeholder: "Username or Email",
					}}
				/>
		
				<InputFieldGroup 
					name="password"
					type="password"
					custom={{
						placeholder: "Password",
					}}
				/>

				{ errorMessage && 
					<div className="auth-page__error">
						<Card 
							color="error" 
							shadow={false}
							materialIcon="error">
							{errorMessage}
						</Card>
					</div> 
				}
		
				<ButtonGroup className="auth-page__button-group">
					<Button color="secondary">Sign In</Button>
				</ButtonGroup>
			</form>
		</Aux>
	);
}

const validate = values => {
	const errors = {};

	if (!values.username) {
		errors.username = "An email or username is required!";
	}

	if (!values.password) {
		errors.password = "An email or username is required!";
	}
	return errors;
}

export default reduxForm({
	form: 'authForm',
	validate,
})(AuthForm);


// WEBPACK FOOTER //
// ./src/components/auth/AuthForm/index.js